export default {
    VoucherReport: 1,
    StaticReport : 2,
    DynamicReport : 3,
    UNCMergeReport: 4,
};
  